import { render, staticRenderFns } from "./Devicesnew.vue?vue&type=template&id=78e542c6&scoped=true&"
import script from "./Devicesnew.vue?vue&type=script&lang=js&"
export * from "./Devicesnew.vue?vue&type=script&lang=js&"
import style0 from "./Devicesnew.vue?vue&type=style&index=0&id=78e542c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e542c6",
  null
  
)

export default component.exports